<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xi"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td class="tdleft">AB</td>
<td class="tdleft">Anchor Bible</td>
</tr>
<tr>
<td class="tdleft">ACCS</td>
<td class="tdleft">Ancient Christian Commentary on Scripture</td>
</tr>
<tr>
<td class="tdleft">ACNT</td>
<td class="tdleft">Augsburg Commentaries on the New Testament</td>
</tr>
<tr>
<td class="tdleft">ACW</td>
<td class="tdleft">Ancient Christian Writers</td>
</tr>
<tr>
<td class="tdleft"><i>ANF</i></td>
<td class="tdleft"><i>Ante-Nicene Fathers</i>, 10 vols. Edited by Alexander Roberts and James Donaldson. Buffalo, NY: Christian Literature, 1885–1887; reprint, Grand Rapids: Eerdmans, 1951–1956; reprint, Peabody, MA: Hendrickson, 1994.</td>
</tr>
<tr>
<td class="tdleft">BCOTWP</td>
<td class="tdleft">Baker Commentary on the Old Testament Wisdom and Psalms</td>
</tr>
<tr>
<td class="tdleft">BECNT</td>
<td class="tdleft">Baker Exegetical Commentary on the New Testament</td>
</tr>
<tr>
<td class="tdleft">CBQMS</td>
<td class="tdleft">Catholic Biblical Quarterly Monograph Series</td>
</tr>
<tr>
<td class="tdleft">CC</td>
<td class="tdleft">Continental Commentaries</td>
</tr>
<tr>
<td class="tdleft">CEB</td>
<td class="tdleft">Common English Bible</td>
</tr>
<tr>
<td class="tdleft">CO</td>
<td class="tdleft"><i>Corpus Reformatorum: Ioannis Calvini Opera quae supersunt omnia</i>, ed. W. Baum et al. Brunswick: C.A. Schwetschke &amp; Filium, 1863–1900.</td>
</tr>
<tr>
<td class="tdleft"><i>DBW</i></td>
<td class="tdleft"><i>Dietrich Bonhoeffer Werke</i>, 17 vols. Edited by Eberhard Bethge et al. Munich: Chr. Kaiser/Güttersloher Verlagshaus, 1986–99.</td>
</tr>
<tr>
<td class="tdleft"><i>DBWE</i></td>
<td class="tdleft"><i>Dietrich Bonhoeffer Works</i>, English edition, 17 vols. Edited by Victoria J. Barnett, Wayne Whitson Floyd Jr., and Barbara Wojhoski. Minneapolis: Fortress, 1996–2015.</td>
</tr>
<tr>
<td class="tdleft">ESV</td>
<td class="tdleft">English Standard Version</td>
</tr>
<tr>
<td class="tdleft">IBC</td>
<td class="tdleft">Interpretation: A Bible Commentary for Teaching and Preaching</td>
</tr>
<tr>
<td class="tdleft"><a id="page_xii">ICC</a></td>
<td class="tdleft">International Critical Commentary</td>
</tr>
<tr>
<td class="tdleft">JPS</td>
<td class="tdleft">Jewish Publication Society</td>
</tr>
<tr>
<td class="tdleft">JSNTSup</td>
<td class="tdleft">Journal for the Study of the New Testament Supplement Series</td>
</tr>
<tr>
<td class="tdleft">JSPSup</td>
<td class="tdleft">Journal for the Study of the Pseudepigrapha Supplement Series</td>
</tr>
<tr>
<td class="tdleft">LCC</td>
<td class="tdleft">Library of Christian Classics</td>
</tr>
<tr>
<td class="tdleft">LNTS</td>
<td class="tdleft">Library of New Testament Studies</td>
</tr>
<tr>
<td class="tdleft">NCB</td>
<td class="tdleft">New Century Bible Commentary</td>
</tr>
<tr>
<td class="tdleft">NICNT</td>
<td class="tdleft">New International Commentary on the New Testament</td>
</tr>
<tr>
<td class="tdleft">NICOT</td>
<td class="tdleft">New International Commentary on the Old Testament</td>
</tr>
<tr>
<td class="tdleft">NIV</td>
<td class="tdleft">New International Version</td>
</tr>
<tr>
<td class="tdleft"><i>NPNF </i><sup>1</sup></td>
<td class="tdleft"><i>A Select Library of Nicene and Post-Nicene Fathers of the Christian Church</i>, 1st series, 14 vols. Edited by Philip Schaff et al. Buffalo, NY: Christian Literature, 1887–1894; reprint, Grand Rapids: Eerdmans, 1952–1956; reprint, Peabody, MA: Hendrickson, 1994.</td>
</tr>
<tr>
<td class="tdleft">NRSV</td>
<td class="tdleft">New Revised Standard Version</td>
</tr>
<tr>
<td class="tdleft">OSHT</td>
<td class="tdleft">Oxford Studies in Historical Theology</td>
</tr>
<tr>
<td class="tdleft">OTL</td>
<td class="tdleft">Old Testament Library</td>
</tr>
<tr>
<td class="tdleft">PG</td>
<td class="tdleft">Patrologia graeca [= <i>Patrologiae Cursus Completus</i>: Series Graeca]. Edited by Jacques-Paul Migne. 162 vols. Paris, 1857–1886.</td>
</tr>
<tr>
<td class="tdleft">PTMS</td>
<td class="tdleft">Pittsburgh Theological Monograph Series</td>
</tr>
<tr>
<td class="tdleft">RSV</td>
<td class="tdleft">Revised Standard Version</td>
</tr>
<tr>
<td class="tdleft">SBL</td>
<td class="tdleft">Society of Biblical Literature</td>
</tr>
<tr>
<td class="tdleft">SBT</td>
<td class="tdleft">Studies in Biblical Theology</td>
</tr>
<tr>
<td class="tdleft">SFEG</td>
<td class="tdleft">Schriften der Finnischen Exegetischen Gesellschaft</td>
</tr>
<tr>
<td class="tdleft">Siphrut</td>
<td class="tdleft">Siphrut: Literature and Theology of the Hebrew Scriptures</td>
</tr>
<tr>
<td class="tdleft">SP</td>
<td class="tdleft">Sacra Pagina</td>
</tr>
<tr>
<td class="tdleft">SVTP</td>
<td class="tdleft">Studia in Veteris Testamenti Pseudepigraphica</td>
</tr>
<tr>
<td class="tdleft">WBC</td>
<td class="tdleft">Word Biblical Commentary</td>
</tr>
<tr>
<td class="tdleft">WUNT</td>
<td class="tdleft">Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?788e4c83